import { objOf } from 'ramda';
import { compose, withHandlers, withProps, defaultProps } from 'recompose';

import connect from 'app/libs/connect';
import Button from 'app/components/Button/Button';
import { userFlow } from 'app/features/user/selectors';
import {
  freeTrialUrl,
  checkoutUrlByPropsProduct,
} from 'app/features/checkout/selectors';
import { isProductWithOnePlan } from 'app/features/products/selectors';
import { productCtaClicked } from 'app/features/landing/actions';
import { REGISTER_PATH, BILLING_PATH } from 'app/router/constants/paths';
import {
  ANONYMOUS,
  DIRECT_TO_PAY,
  FREE_TRIAL_ELIGIBLE,
} from 'app/features/user/constants/userFlow';
import noop from 'app/libs/noop';

const selectProductLink = ({
  userFlow,
  freeTrialUrl,
  checkoutUrlByPropsProduct,
  isProductWithOnePlan,
}) => {
  if (userFlow === DIRECT_TO_PAY)
    return isProductWithOnePlan ? checkoutUrlByPropsProduct : BILLING_PATH;
  if (userFlow === ANONYMOUS) return REGISTER_PATH;
  if (userFlow === FREE_TRIAL_ELIGIBLE) return freeTrialUrl;

  return checkoutUrlByPropsProduct;
};

const onClick = props => () => {
  props.handleClick(props);
  props.productCtaClicked(props);
};

const state = {
  userFlow,
  freeTrialUrl,
  checkoutUrlByPropsProduct,
  isProductWithOnePlan,
};
const actions = { productCtaClicked };

const ProductCta = compose(
  defaultProps({ type: 'one', handleClick: noop }),
  connect(state, actions),
  withProps(compose(objOf('to'), selectProductLink)),
  withHandlers({ onClick }),
)(Button);

export { onClick, selectProductLink };

export default ProductCta;
